import { css } from '@/styled-system/css';

export const fieldSetStyles = css.raw({
  '& > .c11n_legend': {
    display: 'block',
    marginBlockEnd: 'tightest',
  },

  '& > .c11n_form-help': {
    marginBlockStart: 'tightest',
  },

  // Indent labeled controls only if a legend is present.
  // Using base style instead of variant to ensure this works for composed version.
  '& > .c11n_legend ~ .c11n_labeled-control': {
    marginInlineStart: 'tighter',
  },

  // Hide redundant 'required' and 'optional' indicators in labeled controls.
  '& > .c11n_labeled-control > .c11n_label:after': {
    content: 'none',
  },
});
